<template>
  <div class="user-forgot-password">
    <b-row class="justify-content-center">
      <b-col sm="6">
        <b-alert
          variant="info"
          :show="hasInfo"
          class="mt-3"
        >
          {{ infoMessage }}
        </b-alert>
        <b-alert
          variant="error"
          :show="hasError"
          class="mt-3"
        >
          {{ errorMessage }}
        </b-alert>
        <b-card :header="$t('forgot-password.title')">
          <b-form
            v-show="!codeWasSent"
            @submit.prevent="submitForgotPassword"
          >
            <b-form-group
              label-cols-lg="2"
              :label="$t('login.input.email.label')"
              label-for="input-email"
            >
              <b-form-input
                v-model="username"
                :placeholder="$t('login.input.email.placeholder')"
                type="email"
                id="input-email"
                autocomplete="username"
                :required="true"
              />
            </b-form-group>
            <b-button
              type="submit"
              variant="primary"
              block
            >
              {{ $t('forgot-password.submitButtonText') }}
            </b-button>
          </b-form>
          <b-form
            v-show="codeWasSent"
            @submit.prevent="submitForgotPasswordCode"
          >
            <b-form-group
              label-cols-lg="2"
              :label="$t('register.input.emailVerificationToken.label')"
              label-for="input-code"
            >
              <b-form-input
                v-model="code"
                :placeholder="$t('register.input.emailVerificationToken.placeholder')"
                type="number"
                id="input-code"
                :required="true"
              />
            </b-form-group>
            <b-form-group
              label-cols-lg="2"
              :label="$t('forgot-password.input.newPassword.label')"
              label-for="input-password"
            >
              <b-form-input
                v-model="newPassword"
                :placeholder="$t('forgot-password.input.newPassword.placeholder')"
                type="password"
                id="input-password"
                autocomplete="new-password"
                :required="true"
              />
            </b-form-group>
            <b-button
              type="submit"
              variant="primary"
              block
            >
              {{ $t('forgot-password.submitButtonText') }}
            </b-button>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { Auth } from "aws-amplify";

export default {
  name: "UserForgotPassword",
  data: function() {
    return {
      username: "",
      newPassword: "",
      code: "",
      codeWasSent: false,
      hasInfo: false,
      infoMessage: "",
      hasError: false,
      errorMessage: ""
    };
  },
  methods: {
    submitForgotPassword: function() {
      Auth.forgotPassword(this.username)
        .then(data => {
          console.log("submitForgotPassword", data);
          if (data.CodeDeliveryDetails.Destination) {
            this.hasInfo = true;
            this.infoMessage = this.$i18n.t(
              "forgot-password.verificationCodeInfo",
              [data.CodeDeliveryDetails.Destination]
            );
            this.codeWasSent = true;
          }
        })
        .catch(err => {
          console.log("err", err);
        });
    },
    submitForgotPasswordCode: function() {
      Auth.forgotPasswordSubmit(this.username, this.code, this.newPassword)
        .then(data => {
          console.log("submitForgotPasswordCode Success:", data);
        })
        .catch(err => {
          console.log("submitForgotPasswordCode Error:", err);
        });
    },
    getUsernameFromParam: function() {
      if (this.$route.query.email) {
        this.username = this.$route.query.email;
      }
    }
  },
  watch: {},
  created() {
    this.getUsernameFromParam();
  }
};
</script>